export const DEMO_MATCHES = [
  {
    slug: 'cyberlab-vs-qumys', tournament_key: 'cs2-open-2026', discipline: 'cs2',
    title: 'CyberLab — Qumys Esports', stage: 'Полуфинал · Upper bracket', status: 'live', best_of: 3,
    source_mode: 'auto', version: 18, current_map: 'Mirage', round: 19,
    teams: [{ name: 'CyberLab', tag: 'CL', score: 10, maps: 1 }, { name: 'Qumys Esports', tag: 'QMS', score: 8, maps: 0 }],
    maps: [{ name: 'Ancient', a: 13, b: 7, status: 'finished' }, { name: 'Mirage', a: 10, b: 8, status: 'live' }, { name: 'Nuke', a: null, b: null, status: 'pending' }],
    players: [
      { team: 0, nick: 'art1x', kills: 19, deaths: 12, assists: 5, adr: 92.4, hs: 47, rating: 1.31 },
      { team: 0, nick: 'frost', kills: 17, deaths: 13, assists: 7, adr: 86.1, hs: 41, rating: 1.22 },
      { team: 0, nick: 'nomad', kills: 14, deaths: 14, assists: 4, adr: 74.8, hs: 53, rating: 1.07 },
      { team: 0, nick: 'skeen', kills: 12, deaths: 15, assists: 8, adr: 69.2, hs: 38, rating: 0.98 },
      { team: 0, nick: 'viper', kills: 11, deaths: 14, assists: 6, adr: 65.7, hs: 55, rating: 0.94 },
      { team: 1, nick: 'qz1', kills: 18, deaths: 15, assists: 3, adr: 88.7, hs: 61, rating: 1.19 },
      { team: 1, nick: 'youngKZ', kills: 16, deaths: 14, assists: 5, adr: 81.5, hs: 50, rating: 1.12 },
      { team: 1, nick: 'dastan', kills: 13, deaths: 15, assists: 7, adr: 72.1, hs: 44, rating: 1.01 },
      { team: 1, nick: 'molot', kills: 10, deaths: 15, assists: 4, adr: 61.9, hs: 40, rating: 0.88 },
      { team: 1, nick: 'seven', kills: 9, deaths: 14, assists: 6, adr: 58.4, hs: 33, rating: 0.84 },
    ],
    rounds: ['a','a','b','a','b','b','a','a','a','b','a','b','b','a','a','b','a','b'],
    events: [
      { id: 3, type: 'round_end', payload: { text: 'Qumys забирает 18-й раунд · 10:8' } },
      { id: 2, type: 'clutch', payload: { text: 'qz1 выигрывает клатч 1 в 2' } },
      { id: 1, type: 'round_end', payload: { text: 'CyberLab выигрывает 17-й раунд · 10:7' } },
    ],
  },
  {
    slug: 'nomads-vs-vertex', tournament_key: 'cs2-open-2026', discipline: 'cs2', title: 'Nomads — Vertex',
    stage: 'Полуфинал · Lower bracket', status: 'scheduled', best_of: 3, source_mode: 'manual', scheduled_at: '2026-08-05T19:30:00Z',
    teams: [{ name: 'Nomads', tag: 'NMD', score: 0, maps: 0 }, { name: 'Vertex', tag: 'VTX', score: 0, maps: 0 }], players: [], maps: [], rounds: [], events: [],
  },
];

export const demoForTournament = (key, discipline = 'cs2') => {
  const exact = DEMO_MATCHES.filter((m) => m.tournament_key === key);
  if (exact.length) return exact;
  const base = JSON.parse(JSON.stringify(DEMO_MATCHES[0]));
  base.tournament_key = key;
  base.discipline = discipline;
  base.slug = `${key}-demo-live`;
  base.title = discipline === 'mlbb' ? 'Aqtobe Wolves — Steppe Five' : base.title;
  if (discipline === 'mlbb') {
    base.current_map = 'Игра 2';
    base.teams = [{ name: 'Aqtobe Wolves', tag: 'AW', score: 14, maps: 1 }, { name: 'Steppe Five', tag: 'S5', score: 11, maps: 0 }];
    base.players = base.players.map((p, i) => ({ team: p.team, nick: p.nick, kills: 2 + (i % 6), deaths: 1 + (i % 4), assists: 3 + (i % 8), gold: 7200 + i * 310, rating: p.rating }));
  }
  return [base];
};
